// extracted by mini-css-extract-plugin
export default {"illustration":"_401-page_illustration__sZM54","illustrationContainer":"_401-page_illustrationContainer__jjgaF"};